import BaseAPI from './BaseAPI';

export default class MessageAPI extends BaseAPI {
  static send(data) {
    return this.execute('post', `/messages`, { data });
  }
}
